import { router } from "../routes";

export default {
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: parseInt(this.$route.query.page) || 1,
        total: 0,
      },
      searchQuery: '',
      sortBy: '',
      sortOrder: '',
      currentPageManuallyChanged: false,
    };
  },
  computed: {
    currentPage() {
      return this.pagination.currentPage;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  methods: {
    sortChange({ prop, order }) {
      this.sortBy = prop;
      this.sortOrder = order;
      this.pagination.currentPage = 1;
      this.loadPage(this.currentPage, this.searchQuery, prop, order);
    },
    search() {
      this.pagination.currentPage = 1;
      this.loadPage(1, this.searchQuery);
    },
  },
  mounted() {
    let currPage = this.$route.query.page;
    if (currPage && parseInt(currPage) !== this.pagination.currentPage) {
      this.pagination.currentPage = parseInt(currPage);
      this.currentPageManuallyChanged = true;
    }
  },
  watch: {
    currentPage() {
      this.loadPage(this.currentPage, this.searchQuery, this.sortBy, this.sortOrder);
      if (!this.currentPageManuallyChanged) {
        this.currentPageManuallyChanged = false;
        router.replace({query: {
          page: this.currentPage,
        }});
      }
    },
  },
};
